module.exports = __webpack_public_path__ + "static/img/no-image.2102723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/no-image.png
// module id = UwFm
// module chunks = 0